import { decode } from "js-base64";
import { IFormValues, Step, StepType } from "./components/InspectionForm";
import { Image } from "./hooks/useImageUploader";
import { Polygon } from "ol/geom";

export const fromGlobalID = (id: string) => {
  return decode(id).split(":")[1];
};

export function formatDateShort(input?: string) {
  return input
    ? new Date(input).toLocaleDateString("nl-nl", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";
}

export function formateDateTimeShort(input?: string) {
  return input
    ? new Date(input).toLocaleDateString("nl-nl", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";
}

export function compareDates(dateA: Date, dateB: Date): number {
  return dateA.getTime() < dateB.getTime() ? -1 : 1;
}

export function isStepValid(step: Step, answer: IFormValues, images: Image[]) {
  const { type } = step;
  switch (type) {
    case StepType.photo:
      if (step.add_mandatory) {
        let image_exists = false;
        images.forEach((image) => {
          if (image?.metadata && image.metadata.step === step.key) {
            image_exists = true;
          }
        });
        return image_exists;
      } else {
        return true;
      }

    case StepType.open:
      if (step.add_mandatory) {
        return step.add_mandatory && Boolean(answer);
      } else {
        return true;
      }
    case StepType.closed:
    case StepType.radio:
      return Boolean(answer);
    case StepType.checklist:
      return Boolean(
        Object.values(answer || {})?.find((i) => !!i) &&
          Object.values(answer || {}).filter(
            (answer) => typeof answer === "number" && answer < 0
          ).length === 0
      );
    case StepType.multipleChoice:
      return Object.values(answer || {}).some((value) => !!value);

    default:
      return true;
  }
}

export function getCentroid(polygon: any): [number, number] {
  polygon = new Polygon(polygon.coordinates);
  const point = polygon.getInteriorPoint();
  const coordinates = point.getCoordinates();
  return [coordinates[1], coordinates[0]];
}

export function openNavigation(geometry: any): void {
  const center = geometry && getCentroid(geometry);
  if (center) {
    const navigationUrl =
      getUserPlatform() === "ios"
        ? `http://maps.apple.com/?daddr=${center[0]},${center[1]}`
        : `https://www.google.com/maps/dir/?api=1&destination=${center[0]},${center[1]}`;
    window.open(encodeURI(navigationUrl), "_blank");
  }
}

function getUserPlatform(): "ios" | "other" {
  // We can add apple devices to this list if needed, until a more reliable way of detecting ios is found.
  return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)
    ? "ios"
    : "other";
}

export function getWindowHeight(percentage = 100): string {
  return `calc(${percentage} * var(--vh, 1vh))`;
}
